function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */


import _ from 'underscore';
import PaginatedCollection from './paginated_collection';
import Backbone from '@polleverywhere/backbone';
import Report from './report';
import { differenceInMilliseconds, subWeeks } from 'date-fns';
import URI from 'urijs';

var Reports = /*#__PURE__*/function (_PaginatedCollection) {
  _inheritsLoose(Reports, _PaginatedCollection);

  function Reports() {
    return _PaginatedCollection.apply(this, arguments) || this;
  }

  var _proto = Reports.prototype;

  _proto.initialize = function initialize() {
    _PaginatedCollection.prototype.initialize.apply(this, arguments); // Handle URL params


    this.params = new Backbone.Model({
      sort: '-updated_at'
    });
  }
  /*
   * @deprecated
   *
   */
  ;

  _proto.multiSort = function multiSort(attrs, direction) {
    var sorted = attrs[0] === 'polls' ? this.sortBy(function (report) {
      return report.get('poll_ids').length;
    }) : this.sortBy(function (report) {
      /*
       * some attributes might not exist so we grab
       * all of them and return the first non null value
       */
      for (var _i = 0, _Array$from = Array.from(attrs); _i < _Array$from.length; _i++) {
        var attr = _Array$from[_i];

        if (report.get(attr) != null) {
          // downcase attributes that respond to `toLowerCase`
          if (report.get(attr).toLowerCase) {
            return report.get(attr).toLowerCase();
          } else {
            return report.get(attr);
          }
        }
      }
    });
    var collection = direction === 'DESC' ? new Reports(sorted.reverse()) : new Reports(sorted);
    this.trigger('bulkActions:sort', collection);
    return collection;
  }
  /*
   * @returns [Array] Array of started and unstarted reports
   *
   */
  ;

  _proto.inprogress = function inprogress() {
    return this.filter(function (report) {
      var needle = report.state();
      return ['unstarted', 'started'].includes(needle);
    });
  };

  _proto.bulkDestroy = function bulkDestroy(ids) {
    var _this = this;

    var url = URI(this.url).segment('bulk_destroy').addQuery('ids', ids.join(','));
    return this.sync('delete', this, {
      url: url.toString()
    }).done(function () {
      return _this.remove(ids);
    });
  };

  _proto.fetch = function fetch(options) {
    // Default sorting
    if (options == null) {
      options = {};
    }

    if (!options.data) {
      options.data = {};
    }

    _.defaults(options.data, {
      search: this.params.get('search'),
      sort: this.params.get('sort')
    });

    return _PaginatedCollection.prototype.fetch.call(this, options);
  };

  _proto.hasRecentRuns = function hasRecentRuns() {
    var recentCutOff = subWeeks(new Date(), 2);
    return this.length > 0 && this.any(function (report) {
      return differenceInMilliseconds(new Date(report.get('finished_at')), recentCutOff) > 0;
    });
  };

  _createClass(Reports, [{
    key: "model",
    get: function get() {
      return Report;
    }
  }, {
    key: "url",
    get: function get() {
      return '/api/reports';
    }
  }]);

  return Reports;
}(PaginatedCollection);

export { Reports as default };